// extracted by mini-css-extract-plugin
export default {"soldOverlay":"styles_soldOverlay__YNPQQ","children":"styles_children__S6p2s"};